
import { defineComponent } from "vue";
import axios from "axios";
export default defineComponent({
    name: "App",
    setup() {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve({
                msg: '2000'
            }), 2000)
        })

        // return axios.get("/data/arr.json").then((res) => ({
        //     msg: res.data,
        // }));
    },
    // async setup() {
    //     const { data } = await axios.get("/data/arr.json");
    //     return {
    //         msg: data,
    //     };
    // }
});
